"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const button_1 = __importDefault(require("@kyruus/button"));
const react_1 = __importStar(require("react"));
const ArrowLeft2_1 = __importDefault(require("@kyruus/react-ikons/ArrowLeft2"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const react_intl_1 = require("react-intl");
const MobileHeader = (0, react_1.forwardRef)((props, ref) => {
    const { goBack, headerMessage } = props;
    const intl = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement(styles_1.MobileHeaderContainer, { "data-testid": "mobile-header", ref: ref },
        react_1.default.createElement(styles_1.MobileHeaderContent, null,
            react_1.default.createElement(button_1.default, { "data-testid": "backButton", mode: "flat", onClick: goBack, "aria-label": intl.formatMessage(messages_1.default.ariaGoBack) },
                react_1.default.createElement(ArrowLeft2_1.default, { "aria-hidden": true, size: "24px" })),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, headerMessage)))));
});
MobileHeader.displayName = 'MobileHeader';
exports.default = MobileHeader;
//# sourceMappingURL=MobileHeader.js.map